import { z } from "zod/v4";
import { availabilityResponseSchema, userAvailabilitySchema } from "../../schemas/training";
import { fetchApi } from "../internal";

export const availability = {
	list: (clubId: string, seasonId: string) =>
		fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}/availability`,
			z.array(userAvailabilitySchema),
		),
	me: (clubId: string, seasonId: string) =>
		fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}/availability/me`,
			availabilityResponseSchema,
		),
	setForUser: (clubId: string, seasonId: string, userId: string, data: unknown) =>
		fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}/availability/${userId}`,
			availabilityResponseSchema,
			{ body: JSON.stringify(data), method: "PUT" },
		),
	setMine: (clubId: string, seasonId: string, data: unknown) =>
		fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}/availability/me`,
			availabilityResponseSchema,
			{ body: JSON.stringify(data), method: "PUT" },
		),
};
